import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    onlymain: true,
    onlyroom: true
  },
  mutations: {
    uodataMain(state, val) {
      state.onlymain = val
    },
    uodataRoom(state, val) {
      state.onlyroom = val
    },
  },
  actions: {
  },
  modules: {
  }
})
